import lottie from 'lottie-web';

class LottieAnimation {
  constructor() {
    this.animations = Array.from(document.querySelectorAll('.js-lottie-animation'));
    this.init();
  }

  init() {
    this.animations.forEach(animation => {
      lottie.loadAnimation({
        container: animation,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: animation.dataset.json,
        rendererSettings: {
          viewBoxOnly: true, // This prevents lottie from inlining CSS height, width, and transform properties.
        },
      });
    });
  }
}

export default LottieAnimation;
